import { ReactNode } from 'react'

import { Cell } from '../components/Cell'
import { Row } from '../components/Row'
import { useSchedule } from '../useSchedule'

type FullSpanProps = {
  children?: ReactNode
}

export const FullSpan = (props: FullSpanProps) => {
  const { columnCount } = useSchedule()

  return (
    <>
      <Row>
        <Cell
          style={{ padding: 0, height: 0, position: 'sticky', left: 0 }}
          colSpan={columnCount}
          isTitle
        >
          {props.children}
        </Cell>
      </Row>
    </>
  )
}
